// libs
import { styled } from '@nykaa/ui-components';

export const Image = styled.img<{ width: number; height: number }>`
  ${({ width }) => width && `width: ${width}px;`}
  ${({ height }) => height && `height: ${height}px;`}
  background-repeat: no-repeat;
`;
